var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCookie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 124,
    viewBox: "0 0 121 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4999 15.1696C82.4665 15.1696 101.4 28.9695 109.967 48.7363C104.683 25.0529 84.5165 7.35292 60.4999 7.35292C36.4832 7.35346 16.3165 25.0529 11.0332 48.7529C19.5999 28.9696 38.5499 15.1863 60.4999 15.1863V15.1696Z",
    fill: "url(#paint0_linear_310_12263)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1502 117.636C44.9503 108.103 54.2669 91.0863 58.8002 70.6696C58.9836 69.8693 59.6834 69.3029 60.5167 69.3029C61.35 69.3029 62.0499 69.8693 62.2332 70.6696C66.7667 91.0529 76.0669 108.086 87.8833 117.636C102.6 107.736 111.367 90.9029 111.367 72.3862C111.367 42.7696 88.5666 18.6862 60.5332 18.6862C32.4999 18.6862 9.66797 42.7696 9.66797 72.3862C9.66797 90.9196 18.418 107.736 33.1513 117.636H33.1502Z",
    fill: "url(#paint1_linear_310_12263)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_12263",
    x1: 4.60254,
    y1: 61.1729,
    x2: 95.4596,
    y2: -14.3446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_310_12263",
    x1: 3.05756,
    y1: 147.321,
    x2: 143.083,
    y2: 97.2658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5784F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5B6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookie);
export default __webpack_public_path__ + "static/media/cookie.bfb69725878987657d12f2c7a9c4bc30.svg";
export { ForwardRef as ReactComponent };